<template lang="pug">
  section
    h2.en( :class="checkSize(en)", v-html="en" )
    h2.jp( v-html="jp" )
</template>

<script>
export default {
  props: {
    en: String,
    jp: String
  },

  methods: {
    checkSize(text) {
      if (text.length > 15) {
        return {
          big: false,
          small: true
        };
      } else {
        return {
          big: true,
          small: false
        };
      }
    }
  }
};
</script>

<style scoped lang="scss">
section {
  position: fixed;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 99999;

  h2 {
    &.en {
      padding: 2rem;
      font-family: "ELECNA", sans-serif;
      font-weight: 500;
      color: #fff;
      filter: drop-shadow(0px 0px 2px rgba(0, 0, 0, 1));

      &.big {
        font-size: 12vw;
        line-height: 16vw;
        letter-spacing: 0.25vw;
      }
      &.small {
        font-size: 6vw;
        line-height: 10vw;
        letter-spacing: 0.25vw;
      }
    }

    &.jp {
      font-size: 4vw;
      font-weight: 700;
      letter-spacing: 0.5rem;
      padding: 1rem;
      color: #fff;
      filter: drop-shadow(0px 0px 2px rgba(0, 0, 0, 1));
    }
  }
}

@media screen and (min-width: 768px) {
  section {
    h2 {
      &.en {
        padding: 4rem;
      }

      &.jp {
        font-size: 1.2vw;
      }
    }
  }
}
</style>
